export default "__VITE_ASSET__9vIwAa0$__"